import "./App.css";
import MainBody from "./Components/MainBody";
import { RoiProvider } from "./Context/RoiContex";
import Banner from "./Components/Banner/Banner";
import Footer from "./Components/Footer/Footer";
import NavBar from "./Components/Navbar/NavBar";
import SiteFooder from "./Components/Footer/SiteFooder";

function App() {
  return (
    <>
      <RoiProvider>
        <div className="font-sourcesanspro">
          {/* <NavBar /> */}
          <Banner />
          <MainBody></MainBody>
          <Footer />
          {/* <SiteFooder /> */}
        </div>
      </RoiProvider>
    </>
  );
}

export default App;
